import {Component, EventEmitter, Output, ViewChild} from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {UtilProvider} from "../../../providers/util/util";
import {GroupProvider} from "../../../providers/group/group";
import {Group} from "../../../class/chatroom";
import {CustomLoadingProvider} from "../../../providers/custom-loading/custom-loading";
import {MyAlertProvider} from "../../../providers/my-alert/my-alert";
import {ChatroomPickerComponent} from "../../../components/chatroom-picker/chatroom-picker";
import {SensitiveStep_2Page} from "../sensitive-step-2/sensitive-step-2";

/**
 * Generated class for the SensitiveStep_1Page page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-sensitive-step-1',
  templateUrl: 'sensitive-step-1.html',
})
export class SensitiveStep_1Page {

  @ViewChild(ChatroomPickerComponent) picker;

  //分组数据
  groupList = [];

  //已经选中的chatrooms
  choosedChatrooms = [];

  //已选中的敏感词
  sensitiveWords = [];

  //当前的敏感词 ID
  ruleId;

  remark;

  cover;
  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public util: UtilProvider,
              public groupService: GroupProvider,
              private csLoader: CustomLoadingProvider,
              private myAlert: MyAlertProvider) {
    this.choosedChatrooms = this.navParams.data['chatroom_list'] || [];
    this.sensitiveWords = this.navParams.data['sensitive_word_list'] || [];
    this.remark = this.navParams.data['remark'] || '';
    this.ruleId = this.navParams.data['rule_id'];
    this.cover = this.navParams.data['cover'];

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SensitiveStep_1Page');

    this.getGroupList();
  }

  ionViewWillLoad(){
    this.csLoader.showLoader();
  }

  getGroupList() {
    this.groupService.getGroupList().subscribe(res => {
      this.csLoader.dismissLoader();

      //数据赋值
      this.groupList = res['content']['group_list']
        .map(item => new Group(item))
        .filter(item => item.chatroom_list.length);

      //初始选中的群
      this.groupList.forEach(group => {
        group.chatroom_list.forEach(chatroom => {
          if (this.choosedChatrooms.some(
              chatroomChoosed => chatroomChoosed.chatroomname == chatroom.chatroomname)) {
            chatroom['is_choosed'] = true;
          } else {
            chatroom['is_choosed'] = false;
          }
        });
      });

    }, err=> {
      this.csLoader.dismissLoader();
      // let alertObj ={
      //   type:'error',
      //   title:'default',
      //   message: 'default',
      //   success: {
      //     text: '知道了',
      //   },
      // };
      // this.myAlert.showAlert(alertObj);
    });
  }

  onFinished(chatrooms){
    console.log(chatrooms);
    this.util.myNav(this.navCtrl,SensitiveStep_2Page, {
      chatroom_list: chatrooms,
      rule_id: this.ruleId,
      remark:this.remark,
      cover:this.cover,
      sensitive_word_list: this.sensitiveWords
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/sensitive/sensitive-step-1/sensitive-step-1.ts